<template>
  <!-- menu with submenu -->
  <li v-if="menu.icon == 'li'" class="nav-header">
    <!-- {{menu.title}} -->
  </li>
  <li v-else-if="menu.children && menu.children.find((x) => x.is_show_sidebar == 1)" class="has-sub" v-bind:class="{ active: subIsActive(menu.path), expand: this.stat == 'expand' }">
    <a href="#" v-on:click.prevent.stop="expand($event)" @mouseover="mouseOver(menu.children, $event)" @mouseleave="hideFloatSubmenu">
      <span v-if="menu.badge" class="badge pull-right">{{ menu.badge }}</span>
      <b v-else class="caret"></b>
      <span v-if="isQrCodes(menu)" class="sidebar-icon-svg">
        <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.947 0H0V5.182H6.947V0Z" fill="currentColor"/>
          <path d="M11.9999 0H8.21094V5.182H11.9999V0Z" fill="currentColor"/>
          <path d="M5.053 12H12V6.818L5.053 6.818L5.053 12Z" fill="currentColor"/>
          <path d="M6.24657e-05 12H3.78906L3.78906 6.818L6.24657e-05 6.818L6.24657e-05 12Z" fill="currentColor"/>
        </svg>
      </span>
      <i v-else-if="menu.icon" v-bind:class="menu.icon"></i>
      <div v-if="menu.img" class="icon-img"><img v-bind:src="menu.img" alt="" /></div>
      <span>
        {{ formatMenuTitle(menu.title) }}
        <span v-if="menu.label" class="label label-theme">{{ menu.label }}</span>
        <i v-if="menu.highlight" class="fa fa-paper-plane text-theme"></i>
      </span>
    </a>
    <ul class="sub-menu" v-bind:class="{ 'd-block': this.stat == 'expand', 'd-none': this.stat == 'collapse' }" v-bind:style="{ marginTop: pageOptions.pageSidebarMinified ? -(scrollTop + 40) + 'px' : '' }">
      <template v-for="submenu in menu.children">
        <sidebar-nav-list v-bind:menu="submenu" v-bind:key="submenu.path" ref="sidebarNavList" v-on:calcFloatSubmenu="handleCalcFloatSubmenu" v-on:collapse-other="handleCollapseOther(submenu)"></sidebar-nav-list>
      </template>
    </ul>
  </li>

  <!-- menu without submenu -->
  <router-link v-else-if="menu.is_show_sidebar" v-bind:to="menu.path" active-class="active" tag="li" v-on:click.native="collapseOther()">
    <a>
      <span v-if="menu.badge" class="badge pull-right">{{ menu.badge }}</span>
      <span v-if="isQrCodes(menu)" class="sidebar-icon-svg">
        <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.947 0H0V5.182H6.947V0Z" fill="currentColor"/>
          <path d="M11.9999 0H8.21094V5.182H11.9999V0Z" fill="currentColor"/>
          <path d="M5.053 12H12V6.818L5.053 6.818L5.053 12Z" fill="currentColor"/>
          <path d="M6.24657e-05 12H3.78906L3.78906 6.818L6.24657e-05 6.818L6.24657e-05 12Z" fill="currentColor"/>
        </svg>
      </span>
      <i v-else-if="menu.icon" v-bind:class="menu.icon"></i>
      <div v-if="menu.img" class="icon-img"><img v-bind:src="menu.img" alt="" /></div>
      <span>
        {{ formatMenuTitle(menu.title) }}
        <i v-if="menu.highlight" class="fa fa-paper-plane text-theme"></i>
        <span v-if="menu.label" class="label label-theme">{{ menu.label }}</span>
      </span>
    </a>
  </router-link>
</template>

<script>
import SidebarNavList from "./SidebarNavList.vue";
import PageOptions from "@/Options/PageOptions";

export default {
  name: "SidebarNavList",
  props: ["menu", "scrollTop"],
  components: {
    SidebarNavList,
  },
  data() {
    return {
      stat: "",
      pageOptions: PageOptions,
    };
  },
  methods: {
    formatMenuTitle(title) {
      if (!title) return "";
      if (title === "Penerimaan QR Dealer" || title === "Penerimaan QR dealer") {
        return "Penerimaan QR";
      }
      return title;
    },
    isQrCodes(menu) {
      if (!menu) return false;
      const title = (menu.title || "").toLowerCase();
      const path = (menu.path || "").toLowerCase();
      return title === "qr codes" || path === "/qr-code";
    },
    mouseOver: function (data, event) {
      if (this.pageOptions.pageSidebarMinified) {
        var offset = event.target.offsetParent.getBoundingClientRect();
        this.$emit("showFloatSubmenu", data, offset);
      }
    },
    hideFloatSubmenu: function () {
      if (this.pageOptions.pageSidebarMinified) {
        this.$emit("hideFloatSubmenu");
      }
    },
    expand: function () {
      if (this.stat == "") {
        this.stat = this.subIsActive(this.menu.path) ? "collapse" : "expand";
      } else {
        this.stat = this.stat == "expand" ? "collapse" : "expand";
      }
      this.$emit("collapse-other", this.menu);

      if (this.pageOptions.pageSidebarMinified) {
        this.$emit("calcFloatSubmenu");
      }
    },
    handleCalcFloatSubmenu: function () {
      if (this.pageOptions.pageSidebarMinified) {
        this.$emit("calcFloatSubmenu");
      }
    },
    collapse: function (menu) {
      if (this.menu != menu) {
        this.stat = "collapse";
      }
    },
    collapseOther: function () {
      this.$emit("collapse-other", this.menu);
    },
    handleCollapseOther: function (menu) {
      for (var i = 0; i < this.menu.children.length; i++) {
        this.$refs.sidebarNavList[i].collapse(menu);
      }
    },
    subIsActive(path) {
      const paths = Array.isArray(path) ? path : [path];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0;
      });
    },
  },
};
</script>

<style>
.sidebar .nav > li > a .sidebar-icon-svg {
  float: left;
  margin-right: 10px;
  width: 14px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #555;
}

.sidebar .nav > li.active > a .sidebar-icon-svg,
.sidebar .nav > li.has-sub.active > a .sidebar-icon-svg {
  color: #fff !important;
}

.page-sidebar-minified .sidebar .nav > li > a .sidebar-icon-svg {
  margin: 0;
}
</style>
